import React from "react"
import { useIntl } from "react-intl"

import Location from "components/Shared/Filters/modules/Location"
import Selectors from "components/Shared/Filters/modules/Vendor"
import Filters from "components/Shared/Filters"

import * as GlobalFilters from "components/Shared/GlobalFilter/constants"
import filterSwitchingSelectorsConfig from "./filterSwitchingSelectorsConfig"
import Product from "components/Shared/Filters/modules/Product"
import Brands from "components/Shared/Filters/modules/Brand"
import Format from "components/Shared/Filters/modules/Format"
import Channel from "components/Shared/Filters/modules/Channel"

const panelContent: Record<string, JSX.Element> = {
	[GlobalFilters.LOCATION_GROUP_FILTER]: <Location />,
	[GlobalFilters.PRODUCT_GROUP_FILTER]: <Product />,
	[GlobalFilters.BRAND_GROUP_FILTER]: <Brands />,
	[GlobalFilters.FORMAT_GROUP_FILTER]: <Format />,
	[GlobalFilters.CHANNEL_GROUP_FILTER]: <Channel />,
}

const GlobalFilterSwitching = () => {
	const intl = useIntl()
	const menuButtons = [
		{
			title: intl.formatMessage({ id: "phronesis.filters.brandandproduct" }),
			toOpen: GlobalFilters.PRODUCT_GROUP_FILTER,
			dependencies: [GlobalFilters.BRANDS, GlobalFilters.PRODUCTS],
		},
		{
			title: intl.formatMessage({ id: "phronesis.filters.channel" }),
			toOpen: GlobalFilters.CHANNEL_GROUP_FILTER,
			dependencies: [GlobalFilters.CHANNEL],
		},
		{
			title: intl.formatMessage({ id: "phronesis.filters.format" }),
			toOpen: GlobalFilters.FORMAT_GROUP_FILTER,
			dependencies: [GlobalFilters.FORMATS],
		},
		{
			title: intl.formatMessage({ id: "phronesis.filters.groups.location" }),
			toOpen: GlobalFilters.LOCATION_GROUP_FILTER,
			dependencies: [
				GlobalFilters.REGIONS,
				GlobalFilters.COUNTIES,
				GlobalFilters.STORES,
			],
		},
	]

	return (
		<Filters dataMenu={{ panelContent, buttons: menuButtons }}>
			<Selectors
				onChange={() => {}}
				selectProps={filterSwitchingSelectorsConfig}
			/>
		</Filters>
	)
}

export default GlobalFilterSwitching
